/**
 * A pdf.js betoltese - CSAK akkor, amikor tenyleg kell.
 *
 * A konyvtar a workerrel egyutt tobb szaz kilobajt: a fo csomagba teve minden
 * belepeskor letoltodne, pedig a legtobb munkamenetben senki nem nyit PDF-et.
 * Igy az elso PDF-nezes (vagy PDF-feltoltes) tolti be, utana gyorsitotarbol jon.
 */
import type * as PdfJsModule from 'pdfjs-dist';

type PdfJs = typeof PdfJsModule;

let loading: Promise<PdfJs> | null = null;

export function loadPdfJs(): Promise<PdfJs> {
  loading ??= Promise.all([
    import('pdfjs-dist'),
    import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
  ]).then(([pdfjs, worker]) => {
    pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
    return pdfjs;
  });
  return loading;
}
